// @ts-nocheck
import { ShipmentCollectionModel } from "@store/Framework/Types/ApiModels";
import { getShipments, GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetShipmentsApiParameter, ShipmentCollectionModel>;

export const DispatchBeginLoadShipments: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/Shipments/BeginLoadShipments",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getShipments(props.apiParameter);
};

export const DispatchCompleteLoadShipments: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/Shipments/CompleteLoadShipments",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadShipments,
    RequestDataFromApi,
    DispatchCompleteLoadShipments,
];

const loadShipments = createHandlerChainRunner(chain, "LoadShipments");
export default loadShipments;
